/**
 * videoDetailStore
 */
import Vue from 'vue';
import * as types from '../mutation-types';
import * as urls from '../../config/urls';
import * as helpers from '../../utils/helpers';
import auth from '../../utils/auth';


const VIDEOCONTENT = 'VIDEOCONTENT'; // 视频内容
const RECOMMENDELLIST = 'RECOMMENDELLIST'; // 推荐列表
const VIDEO = 'VIDEO'; // 推荐列表
const FILELIST = 'FILELIST'; //
export default {
    namespaced: true,

    state: {
        // videoDetail
        videoDetailList: [],
        videoDetail: {},
        videoDetailContent: [],
        videoRecommendedlist: [],
        videoDetailLoading: false,
        videoDetailExtra: {
            total: 0,
        },
        videoDetailQueries: {
            pagination: 1,
            pageSize: 6,
        },
        fileList: [],
    },

    mutations: {
        [types.UPDATE_LIST](state, {
            subject,
            list,
        }) {
            state[`${subject}List`] = list;
        },
        [types.UPDATE_LOADING_STATUS](state, {
            subject,
            isLoading,
        }) {
            state[`${subject}Loading`] = isLoading;
        },
        [VIDEO](state, { datadetail }) {
            state.videoDetail = datadetail;
        },
        [VIDEOCONTENT](state, { detail2 }) {
            state.videoDetailContent = detail2;
        },
        [RECOMMENDELLIST](state, {
            list,
        }) {
            state.videoRecommendedlist = list;
        },
        [FILELIST](state, { list }) {
            state.fileList = list;
        },

    },

    actions: {
        // videoDetail: 详情
        getVideoDetailDetail({ commit }, { id }) {
            let urlUse = '';

            urlUse = urls.GET_VIDEO_DETAIL;
            const userId = auth.getUserInfo().user_id;
            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {
                        userId,
                        mediaId: id,
                    },
                }).then((response) => {
                    const datadetail = response.data;
                    commit(VIDEO, {
                        datadetail,
                    });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        getNoAuthVideoDetailDetail({ commit }, { id }) {
            let urlUse = '';

            urlUse = urls.GET_VIDEO_DETAIL;

            return new Promise((resolve, reject) => {
                Vue.httpnoauth.get(urlUse, {
                    params: {
                        userId: 1,
                        mediaId: id,
                    },
                }).then((response) => {
                    const datadetail = response.data;
                    commit(VIDEO, {
                        datadetail,
                    });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        getFileList({ commit }, { id }) {
            let urlUse = '';

            urlUse = urls.GET_FILELIST;

            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {
                        programId: id,
                    },
                }).then((response) => {
                    const list = response.data.result;
                    commit(FILELIST, {
                        list,
                    });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        getVideoTrick({ commit }, { id }) {
            const subject = 'videoDetail';
            const param = {
                programId: id,
            };

            return new Promise((resolve2, reject2) => {
                // const urlv = helpers.buildURL(URL1, param.action, param.params);
                Vue.http.post(urls.VIDEO_DTAIL,
                    param).then((response2) => {
                    commit(types.UPDATE_LOADING_STATUS, {
                        subject,
                        isLoading: false,
                    });

                    const detail2 = response2.data.data.result.tracks || {};

                    commit(VIDEOCONTENT, { detail2 });
                    resolve2(response2);
                }).catch((error) => {
                    reject2(error);
                });
            });
        },

        // 推荐列表
        getRecommendedList({ commit, state }, queries) {
            const subject = 'videoDetail';
            const {
                pagination = state[`${subject}Queries`].pagination,
                    pageSize = state[`${subject}Queries`].pageSize,
                    ...otherQueries
            } = queries;
            let urlUse = '';
            // debugger
            urlUse = urls.VIODE_LIST_LOGIN;
            const userId = auth.getUserInfo().user_id;

            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {
                        pageNumber: pageSize,
                        userId,
                        offset: (pagination - 1),
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || {};
                    commit(RECOMMENDELLIST, { list });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        addView(_, formData = {}) {
            let urlUse = urls.ADD_VIDEO_VIEW;

            const data = helpers.pick(formData, [
                'mediaId',
            ]);
            urlUse = `${urlUse}&mediaId=${data.mediaId}`;
            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {}).then(() => {}).catch((error) => {
                    reject(error);
                });
            });
        },

        recordDownloads(_, formData = {}) {
            let urlUse = urls.ADD_VIDEO_DOWNLOAD;

            const data = helpers.pick(formData, [
                'mediaId',
            ]);
            urlUse = `${urlUse}&mediaId=${data.mediaId}`;
            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {}).then(() => {}).catch((error) => {
                    reject(error);
                });
            });
        },


    },
};